import React, { Component } from 'react';

import AirDrawer from '../../../../common/components/AirDrawer';

import './SubscriptionAdvancedFilter.css';
import { inject, observer } from 'mobx-react';
import SubscriptionTypeFilter from './filters/SubscriptionTypeFilter';
import EndDateYearFilter from './filters/EndDateYearFilter';
import SubscriptionStatusFilter from "./filters/SubscriptionStatusFilter";
import ProductFilter from "./filters/ProductFilter";

@inject('translationsStore', 'filterStore')
@observer
export default class SubscriptionAdvancedFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };

    this.SubscriptionStatusFilterRef = React.createRef();
    this.SubscriptionTypeFilterRef = React.createRef();
    this.EndDateYearFilterRef = React.createRef();
    this.ProductFilterRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.subscriptions) {
      this.init(this.props.subscriptions);
    }
  }

  componentWillUnmount() {
    this.props.filterStore.reset();
  }

  componentDidUpdate(prevProps) {
    if (this.props.subscriptions && this.props.subscriptions !== prevProps.subscriptions) {
      this.init(this.props.subscriptions);
    }
  }

  init(subscriptions) {
    this.setState({ subscriptions });
  }

  hide = () => {
    this.setState({ visible: false });
  };

  show = () => {
    this.setState({ visible: true });
  };

  reset = () => {
    this.props.filterStore.reset();
  };

  apply = () => {
    this.props.filterStore.apply();
    this.hide();
  };

  render() {
    const { translationsStore, filterStore } = this.props;
    const { visible } = this.state;
    return (
      <AirDrawer
        width="570px"
        className="SubscriptionAdvancedFilter"
        visible={visible}
        onClose={this.hide.bind(this)}
        title={translationsStore.translate('advancedfilter.title')}
        okLabel={translationsStore.translate('advancedfilter.button.apply')}
        cancelLabel={translationsStore.translate('advancedfilter.button.reset')}
        onOk={this.apply}
        onCancel={this.reset}
        disabled={filterStore.changes === false}
      >
        <ProductFilter ref={this.ProductFilterRef} status={this.props.filterStore.contains('subscriptionFilter_product')} />
        <SubscriptionTypeFilter ref={this.SubscriptionTypeFilterRef} status={this.props.filterStore.contains('subscriptionFilter_subscriptionType')} />
        <SubscriptionStatusFilter ref={this.SubscriptionStatusFilterRef} status={this.props.filterStore.contains('subscriptionFilter_subscriptionStatus')} />
        <EndDateYearFilter ref={this.EndDateYearFilterRef} status={this.props.filterStore.contains('subscriptionFilter_endDate')} />
      </AirDrawer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/SubscriptionAdvancedFilter.js